import React from 'react';
import { Typography } from '@mui/material';
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import Error from './Error.json';
import CommonButton from 'components/commonButton/CommonButton';

function AppError({ error, resetErrorBoundary }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Error,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  return (
    <div className="height100vh flexAlignCenter flexColumn">
      <Player autoplay loop src={Error} style={{ height: '50vh' }}>
        <Controls
          visible={false}
          buttons={['play', 'repeat', 'frame', 'debug']}
        />
      </Player>
      <div className="flexColumn flexAlignCenter">
        <Typography variant="head2" className=" fw600 colorPrimary">
          Something Went Wrong
        </Typography>
        <Typography variant="head3" className=" colorGrey fw600 mb10">
          Error Reported To Admin
        </Typography>
        <CommonButton
          onClick={resetErrorBoundary}
          name={'Try Again'}
          btnClass={'btnYellow btnMedium'}
        />
      </div>
    </div>
  );
}

export default AppError;
